import { createAction } from '@reduxjs/toolkit';

export const toastrUpdateIsShow = createAction('toastr/updateIsShow');
export const toastrUpdateMessage = createAction('toastr/updateMessage');
export const toastrUpdateType = createAction('toastr/updateType');
export const toastrShowSuccess = createAction('toastr/showSuccess');
export const toastrShowError = createAction('toastr/showError');
export const toastrShowInfo = createAction('toastr/showInfo');
// Typed for the TS consumers (`Toastr.tsx`) — inference from a bare `createAction()` call in a .js
// module gives a payloadless creator, and the toast id would not type-check.
/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<number>} */
export const toastrDismiss = createAction('toastr/dismiss');
